import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class NiveauService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/niveau')
                    .then(res => res.data);
    }
    create(newNiveau) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/niveau'
        return axios.post(url,newNiveau)
                    .then(res => res.data);
    }
    update(idNiveau ,newNiveau) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/niveau/'
        return axios.put(url+idNiveau, newNiveau)
                    .then(res => res.data);
    }
    delete(idNiveau) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/niveau/'
        return axios.patch(url+idNiveau)
                    .then(res => res.data)
    }
    get(idBatiment) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/niveau/?idBatiment='+idBatiment
        return axios.get(url)
                    .then(res => res.data)
    }

}